import api from "./index";
import ENDPOINTS from "./endpoints";

export const getNotifications = async (orgId, userId) => {
  const response = await api({
    method: "GET",
    url: ENDPOINTS.NOTIFICATIONS,
    params: { org_id: orgId, user_id: userId },
  });
  return response.data?.data ?? [];
};

export const markNotificationRead = async (orgId, userId, notificationId) => {
  const response = await api({
    method: "PATCH",
    url: ENDPOINTS.NOTIFICATION_READ(notificationId),
    params: { org_id: orgId, user_id: userId },
  });
  return response.data;
};

export const markAllNotificationsRead = async (orgId, userId) => {
  const response = await api({
    method: "POST",
    url: ENDPOINTS.NOTIFICATIONS_READ_ALL,
    data: { org_id: orgId, user_id: userId },
  });
  return response.data;
};

export const deleteNotifications = async (orgId, userId) => {
  const response = await api({
    method: "DELETE",
    url: ENDPOINTS.NOTIFICATIONS,
    params: { org_id: orgId, user_id: userId },
  });
  return response.data;
};
